import { render, staticRenderFns } from "./BaseLanguageSwitcher.vue?vue&type=template&id=e81443ba&scoped=true&"
import script from "./BaseLanguageSwitcher.vue?vue&type=script&lang=ts&"
export * from "./BaseLanguageSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLanguageSwitcher.vue?vue&type=style&index=0&id=e81443ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81443ba",
  null
  
)

export default component.exports